var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"splashscreeen"}},[_c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{attrs:{"name":"modal","id":"overlay"}},[(_vm.locationData.avatar)?_c('div',[_c('div',{staticClass:"avatar",style:({ backgroundImage: 'url(' + _vm.locationData.avatar + ')' })})]):_vm._e()]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }